<!-- 列表页 -->
<template>
  <div class="list">
    <div class="nav-top">
      <i class="iconfont icon-zglsfanhui" @click="toIndex()"></i>
      搜索
    </div>
    <div class="search-box">
      <el-input
        class="search-box-input"
        placeholder="搜索"
        prefix-icon="el-icon-search"
        v-model="keyword"
        clearable
      >
      </el-input>
      <div class="search-box-text" @click="queryInfo()" v-loading.fullscreen.lock="fullscreenLoading">搜索</div>
    </div>

    <div
      class="news"
      v-if="newsContentList.length !== 0"
      v-infinite-scroll="queryInfo"
      style="overflow: auto"
    >
      <div
        class="news-item"
        @click="toDetail(item.id)"
        v-for="(item, index) in newsContentList"
        :key="index"
      >
        <div class="news-item-title" v-html="item.properties.title"></div>
        <div class="news-item-date">
          {{ formatDate(item.$displays.publishedDate) }}
        </div>
      </div>
    </div>
    <div class="protection-nodata" v-if="showNodata">
      <img src="../assets/images/nodata.png" alt="" />
      <p>未查询到相关信息</p>
    </div>
  </div>
</template>

<script>
import api from "../api/index";

export default {
  data() {
    return {
      fullscreenLoading: false,
      keyword: "",
      page: 1,
      newsContentList: [],
      showNodata: false,
      totalPages:1
    };
  },
  created(){
    let keyword = localStorage.getItem('keyword')
    if(keyword){
      this.keyword = keyword
      this.queryInfo()
    }
  },
  watch:{
    keyword(newword,old){
      if(newword !== old){
        this.page = 1
        this.newsContentList= []
      }
    }
  },
  methods: {
    formatDate(date) {
      return api.formatDate(date);
    },
    toDetail(entityId) {
      this.$router.push({
        name: "detail",
        params: { entityId: entityId, from: "searchView" },
      });
    },
    queryInfo() {
      if(this.totalPages < this.page) return;
      this.fullscreenLoading = true;
      localStorage.setItem('keyword',this.keyword)
      let params = {
        keyword: this.keyword,
        page: this.page++,
        size: 10,
      };
      api.queryInfo(params).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code === 1) {
          this.newsContentList = this.newsContentList.concat(res.data.result.content);
          if(this.newsContentList.length === 0) {
            this.showNodata = true
          } else {
            this.showNodata = false;
            this.totalPages = res.data.result.totalPages
          }
        } else {
          this.$message.error(res.data.description)
          this.showNodata = true;
        }
      });
    },
    toIndex() {
      this.$router.push({
        name: "home",
      });
      localStorage.removeItem('keyword')
    },
  },
};
</script>
<style lang='scss' scoped>
.list {
  width: 100%;
  height: 100%;
  background: #f4f6fa;
  overflow: hidden;
  .nav-top {
    position: relative;
    width: 100%;
    height: 2.75rem;
    background: #f4f6fa;
    text-align: center;
    font-weight: 600;
    font-size: 1.06rem;
    color: #323233;
    line-height: 2.75rem;
    .iconfont {
      position: absolute;
      left: 1rem;
      top: 0;
      font-size: 1.25rem;
      color: #323233;
    }
  }
  .search-box {
    display: flex;
    width: 100%;
    height: 3.25rem;
    padding: 0.5rem 1rem;
    box-sizing: border-box;
    background: #f4f6fa;
    .search-box-input {
      flex: 1;
      height: 2.25rem;
      background: #ffffff;
      border-radius: 1.19rem;
      :deep .el-input__inner {
        border-radius: 1.19rem;
        height: 100%;
      }
    }
    .search-box-text {
      margin-left: 0.5rem;
      width: 2rem;
      font-weight: 400;
      font-size: 1rem;
      color: rgba(0, 0, 0, 0.85);
      line-height: 2.2rem;
    }
  }
  .news {
    width: 100%;
    height: calc(100% - 6rem);
    padding: 0.63rem 1rem;
    box-sizing: border-box;
    background: #f4f6fa;
    overflow: auto;
    .news-top {
      position: relative;
    }
    .news-item {
      margin-top: 1rem;
      width: 100%;
      height: 6.25rem;
      padding: 1rem;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 0.5rem;
      .news-item-title {
        height: 2.56rem;
        font-weight: 500;
        font-size: 0.88rem;
        color: rgba(0, 0, 0, 0.85);
        line-height: 1.25rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .news-item-date {
        margin: 0.63rem 0 0.5rem 0;
        text-align: left;
        font-weight: 500;
        font-size: 0.75rem;
        color: rgba(0, 0, 0, 0.25);
        line-height: 1.06rem;
      }
    }
    .news-item:last-child {
      border: 0;
    }
  }
  .protection-nodata {
    margin: 0 auto;
    margin-top: 7.8rem;
    text-align: center;
    font-size: 1rem;
    font-family: sourcefont-Regular, sans-serif;
    font-weight: 400;
    color: #666666;
    line-height: 1rem;
  }

  .protection-nodata > img {
    margin-bottom: 1.25rem;
    width: 132px;
    height: 86px;
  }
}
</style>